import React from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey';

interface Props {
    src: string,
    alt: string,
    onClose: () => void
}

function ImageLightbox({ src, alt, onClose }: Props) {
    useEscapeKey(onClose);

    return (
        <div className="lightbox-overlay" role="dialog" aria-modal="true" aria-label={alt} onClick={onClose}>
            <button className="modal-close lightbox-close" onClick={onClose} aria-label="Close image">✕</button>
            <figure className="lightbox-figure" onClick={e => e.stopPropagation()}>
                <img src={src} alt={alt} className="lightbox-image" />
                <figcaption className="lightbox-caption">{alt}</figcaption>
            </figure>
        </div>
    );
}

export default ImageLightbox;
